<template>
  <div>
    <Banner theme="pink">
      <template v-slot:title> Videos </template>
      <template v-slot:description>
        Videos let you reference a Vimeo video or upload an MP4 directly,
        complete with metadata pulled from Vimeo, an auto-generated preview
        clip, and up to 3 call-to-action buttons.
      </template>
      <template v-slot:image> </template>
    </Banner>

    <Notice type="info" title="Environment Agnostic" style="margin-top: 20px">
      Videos are automatically synced between staging and production — no
      deployment needed.
    </Notice>

    <IndexPageActions
      :sort-list="sortList"
      btn-text="New Video"
      btn-to="/videos/new"
      :sort-by.sync="sortBy"
      search-placeholder="Search Videos"
      :search-text.sync="searchText"
    />

    <ListPanels :loaded="!!list">
      <div v-if="computedList && computedList.length" style="width: 100%">
        <VideoDataTable
          :list="computedList"
          @destroy="destroy"
          @duplicate="duplicate"
        />
      </div>
      <div v-else class="no-entries">No Videos</div>
    </ListPanels>
  </div>
</template>

<script>
import IndexPage from "./index-page";
import VideoDataTable from "@/components/dataview/video.datatable";

export default {
  name: "VideosPage",
  components: {
    VideoDataTable,
  },
  extends: IndexPage,
  metaInfo() {
    return {
      title: "Videos",
    };
  },
  data() {
    return {
      searchFields: ["title", "slug"],
    };
  },
  methods: {
    async fetchList() {
      const { data } = await this.$api.Video.get({
        sort_by: this.sortBy,
      });
      this.list = data;
    },
    async destroy(item) {
      const confirmed = await this.$confirmWindow({
        title: "Are you sure?",
      });
      if (!confirmed) return;

      await this.$api.Video.destroy({ id: item.id });
      this.list = this.list.filter((t) => t.id != item.id);
    },
    async duplicate(item) {
      await this.$api.Video.duplicate({ id: item.id });
      this.fetchList();
    },
  },
};
</script>

<style scoped lang="scss"></style>
